import { z } from 'zod';

import { meetingSchema } from './Meeting';

export const meetingListSchema = z.object({
  items: z.array(meetingSchema),
  total: z.number(),
});

export type MeetingListEntityApi = z.input<typeof meetingListSchema>;
export type MeetingListEntity = z.infer<typeof meetingListSchema>;
